<template>
  <div>
    <doe-label :name="name">
      {{ label }}
    </doe-label>
    <textarea
      :name="name"
      :id="name"
      :rows="rows"
      :value="value"
      :placeholder="placeholder"
      v-validate="validation"
      :data-vv-as="labelAlternate"
      :aria-label="ariaLabel ? ariaLabel : false"
      :aria-labelledby="ariaLabelID ? ariaLabelID : false"
      :aria-describedby="hint ? ariaDescID : false"
      @input="$emit('input', $event.target.value)"
      maxlength="1500"
    ></textarea>
    <doe-error v-if="errors.has(name)" :description="`${name}ErrorDescription`">{{ errors.first(name) }}</doe-error>
    <doe-hint :hint="hint" :description="ariaDescID" />
  </div>
</template>

<script>
import DoeLabel from "@/components/field/Label";
import DoeHint from "@/components/field/Hint";
import DoeError from "@/components/field/Error";

export default {
  name: "DoeTextarea",
  inject: {
    $validator: "$validator"
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    rows: {
      type: Number,
      default: 5
    },
    label: {
      type: String,
      required: true
    },
    labelAlternate: {
      type: String
    },
    ariaLabel: {
      type: String,
      required: false      
    },
    ariaLabelID: {
      type: String,
      required: false
    },
    placeholder: {
      type: String
    },
    hint: {
      type: [Array, String]
    },
    validation: {
      type: [Object, String]
    }
  },
  components: {
    DoeLabel,
    DoeHint,
    DoeError
  },
  computed: {
    ariaDescID() {
      return `${this.name}Description`;
    }
  }
};
</script>

<style lang="scss" scoped>
textarea {
  @apply bg-gray-300 block border border-gray-800 rounded font-sans leading-snug max-w-3xl mb-0 px-3 py-2 subpixel-antialiased text-gray-900 text-xl w-full;
  &:hover {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
  }
  &:focus {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
}
</style>
